module.exports = __webpack_public_path__ + "564a4806d462f83d97ba660647103d6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon.ttf
// module id = 917
// module chunks = 0